import IntegrationMessagesListPage from '../shared/IntegrationMessagesListPage';

const InboxMessagesListPage = () => <IntegrationMessagesListPage kind="inbox" />;

export default InboxMessagesListPage;
